import templateService from '../../services/tickets/template.service.js'

import entityUtility from '../../utils/entity.utility.js'
import httpUtility from '../../utils/http.utility.js'

import { useToast } from '../../composables/useToast.js'

import { t } from '@/i18n'

const toast = useToast()

async function saveTemplate(scope, payload) {
  try {
    let response
    if (payload._id) response = await templateService.update.template(scope, payload._id, payload)
    else response = await templateService.create.template(scope, payload)
    return response.data.item
  } catch (err) {
    toast.error(httpUtility.error.message(err, t('tickets.settings.errors.saveTemplate')))
    return null
  }
}

async function deleteTemplate(scope, id) {
  try {
    await templateService.delete.template(scope, id)
    return true
  } catch (err) {
    toast.error(httpUtility.error.message(err, t('tickets.settings.errors.deleteItem')))
    return false
  }
}

function mapTemplates(array) {
  return entityUtility.map(array, 'title')
}

function findTemplate(id, array) {
  return entityUtility.find(id, array)
}

class TemplateController {
  /**
   * Map each template to `{ value, label }`.
   *
   * @param {object[]} array
   * @returns {Array<{ value: string, label: string }>}
   */
  map(array) {
    return mapTemplates(array)
  }

  /**
   * Look up one template by `id` in `array`. Returns the row, or `null`
   * when `id` is missing or not found.
   *
   * @param {string|null|undefined} id
   * @param {Array<{ _id: string }>} array
   * @returns {object|null}
   */
  find(id, array) {
    return findTemplate(id, array)
  }

  save = {
    /**
     * Create or update a template row. Branches on `payload._id`
     * (truthy → update; omitted → create). Returns the saved template on
     * success, `null` on failure (toasts the error).
     *
     * @param {string} scope - Settings API URL prefix (`ticket-account` or `ticket-group/:id`).
     * @param {object} payload
     * @returns {Promise<object|null>}
     */
    async template(scope, payload) {
      return saveTemplate(scope, payload)
    },
  }

  delete = {
    /**
     * Delete a template row. Returns `true` on success, `false` on
     * failure (toasts the error).
     *
     * @param {string} scope - Settings API URL prefix (`ticket-account` or `ticket-group/:id`).
     * @param {string} id
     * @returns {Promise<boolean>}
     */
    async template(scope, id) {
      return deleteTemplate(scope, id)
    },
  }
}

export default new TemplateController()
